
export const moduleLabels = [
  "adaptability", "self_efficacy", "active_listening",
	"empathy", "time_management", "stress_management",
	"leadership", "motivation", "planning", "decision_making",
	"problem_solving", "learning_strategy", "social_desirability"
] as const;

export type ModuleLabel = typeof moduleLabels[number];

export const weightingModules = ["adaptability",  "self_efficacy",  "active_listening", 
	"empathy",  "time_management",  "stress_management",  
	"planning",  "decision_making",  "problem_solving", // "learning_strategy", "leadership", "motivation"
] as const;

export type WeightingModule = typeof weightingModules[number];

export type Environment = "planet_station" | "construction_site";

export type ReportType = "simplified" | "complete";

export interface CampaignCreation {
	schema_version: string,
  campaign_version: string,
  variant?: "full" | "essentials",
	organization_id: string;
	campaign: {
		parent_workspace_id: string; // "019ae519-a66a-7016-846b-2afc0a198715", // prepare for nested folders/workspaces
		internal_name: string; // "Bee management issue (associate xyz)"
		headline: string; // "Looking for a (bee)keeper",
		tagline: string; // "<p>we want to bee with you</p>", // BAD BAD: HTML injection!!
		job_title: string; // beekeeper,
		locale?: string; // en-US
		force_locale?: boolean;
	},
	branding: {
		banner_image_id: string; //"019ae525-8490-798e-b33c-f3051a532a52",
		background_image_id: string; // "019ae525-c4ca-7708-be3b-d6878a678eb8",
		text_color: string; //"#FFFFFF", // #FFFFFF or #000000 only ?
		highlight_color: string; // "#1234AB",
	},
	assessment: {
		environment?: Environment;
		modules?: ModuleLabel[];
		weighting: { // only applies to scores, not all modules
			required: WeightingModule[];
			primary: WeightingModule[];
			secondary: WeightingModule[];
			ignored: WeightingModule[];
		} | "neutral", // in case of neutral : "weighting": "neutral"
	},
	surveys?: {
		satisfaction: boolean;
		demographic: boolean;
	},
	documents?: {
		certification: {
			send_to_talent: boolean;
		},
		report: {
			send_to_talent: boolean;
			format: ReportType;
		}
	},
}

export type Campaign = CampaignCreation & {
  created_at: string,
	updated_at: string,
  id: string;
  public_invite_id: string;
  archived: boolean;
  auto_activate: boolean;
}

export interface CampaignContext {
  organisationId: string;
	spaceId: string;
  campaignId: string;
}